/**
 * Split a file into `chunkNums` blobs for a multipart upload.
 *
 * Chunk boundaries must be integers: with a fractional size the last boundary
 * (`chunkNums * chunkSize`) can land below `file.size` and silently drop bytes,
 * which S3 accepts as a shorter object.
 *
 * @param {Blob} file
 * @param {number} chunkNums - number of parts the signed URLs were issued for
 * @param {string} [mimeType]
 * @returns {Blob[]} chunks, in part order
 */
export default function buildFileChunks(file, chunkNums, mimeType) {
  const parts = Math.max(1, Math.floor(Number(chunkNums) || 1));
  const chunkSize = Math.ceil(file.size / parts);

  return [...Array(parts).keys()].map((num) => {
    const start = num * chunkSize;
    const isLast = num === parts - 1;
    /** Let the last chunk run to the end of the file so no byte is left behind */
    return isLast
      ? file.slice(start, file.size, mimeType)
      : file.slice(start, start + chunkSize, mimeType);
  });
}
